import React from 'react';
import { connect } from "react-redux";
import './403.scss';
import Logout from './Global/logout'

export class Forbidden extends React.Component{

    componentDidMount = async() => {
      
    }

    RediretToLogin(){
        Logout()
    }

    render(){  
        return(    
            <main 
                className="main404" 
                role="main" 
                style={{overflow: "hieedn" , mawWidth: "100%"}} 
                onClick={() => this.RediretToLogin()}
            >
                <div className="ghost">
                    <div className="ghost--columns">
                        <div className="ghost--column">
                            <div className="code"></div>
                            <div className="code"></div>
                            <div className="code"></div>
                            <div className="code"></div>
                        </div>
                        <div className="ghost--column">
                            <div className="code"></div>
                            <div className="code"></div>
                            <div className="code"></div>
                            <div className="code"></div>
                            
                        </div>
                        <div className="ghost--column">
                            <div className="code"></div>
                            <div className="code"></div>
                            <div className="code"></div>
                            <div className="code"></div>
                        </div>                        
                    </div>

                    <div className="ghost--main">
                        <div className="code"></div>
                        <div className="code"></div>                    
                    </div>
                </div>
    
                <h1 className="police-tape police-tape--1">
                    &nbsp;&nbsp;Zabranjen pristup&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    Zabrenjen Pristup&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    Zabrenjen Pristup&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    Zabrenjen Pristup&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    Zabrenjen Pristup&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    Zabrenjen Pristup&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    Zabrenjen Pristup&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    Zabrenjen Pristup&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </h1>
                    <h1 className="police-tape police-tape--2">
                    Zabranjen pristup&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    Zabrenjen Pristup&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    Zabrenjen Pristup&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    Zabrenjen Pristup&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    Zabrenjen Pristup&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    Zabrenjen Pristup&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    Zabrenjen Pristup&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    Zabrenjen Pristup&nbsp;
                </h1>
            </main>
        )
    }  
}

const mapStateToProps = state => {
    return {
        userLoggedIn: state.user.userLoggedIn,
        role: state.user.role
    };
  };
  
  const mapDispatchToProps = dispatch => {
    return {
      mapState: (type, data) => dispatch({ type: type, data: data}),
      API: (type, data) => dispatch({ type: type, data: data})
    };
  };
  
  
  
  export default connect(
    mapStateToProps,
    mapDispatchToProps
  )(Forbidden);
